import styled from 'styled-components';
import { Card, CardContent, CardDescription, CardHeader, CardTitle, Label } from 'components';

export const Wrapper = styled.div.attrs({
  className: 'mx-auto flex w-full max-w-[1120px] flex-col gap-3 px-3 pt-3 pb-20',
})``;

export const SettingsCard = styled(Card).attrs({
  className: 'gap-0 rounded-md py-0 shadow-xs',
})``;

export const SettingsCardHeader = styled(CardHeader).attrs({
  className: 'px-4 py-3',
})``;

export const SettingsCardContent = styled(CardContent).attrs({
  className: 'flex flex-col gap-2 px-4 pb-4',
})``;

export const SettingsCardTitle = styled(CardTitle).attrs({
  className: 'text-base font-semibold',
})``;

export const SettingRow = styled.div.attrs({
  className: 'flex items-start gap-2',
})``;

export const SettingText = styled.div.attrs({
  className: 'flex min-w-0 flex-1 flex-col gap-0.5',
})``;

export const SettingLabel = styled(Label).attrs<{ $active: boolean }>((props) => ({
  className: `cursor-pointer text-sm font-medium${props.$active ? '' : ' text-muted-foreground'}`,
}))<{ $active: boolean }>``;

export const SettingDescription = styled(CardDescription).attrs({
  className: 'text-sm text-muted-foreground',
})``;

export const AlwaysAvailableBadge = styled.span.attrs({
  className: 'shrink-0 rounded-md bg-muted px-2 py-0.5 text-xs font-medium',
})``;

export const SettingsHint = styled.p.attrs({
  className: 'border-t pt-2 text-xs text-muted-foreground',
})``;
